import React from "react";

// Alta Agency logo — two variants
// NOTE: the source file names are misleading. Verified via pixel analysis:
//  - The "Preto.png" asset is actually WHITE artwork (used on dark backgrounds).
//  - The "vermelho.png" asset is actually BLACK artwork (used on light backgrounds).
export const LOGO_BLACK = "https://customer-assets.emergentagent.com/job_shambala-retreat/artifacts/ko0gibel_Paulo%20Fagotti%20-%20Logo%20vermelho.png";
export const LOGO_WHITE = "https://customer-assets.emergentagent.com/job_shambala-retreat/artifacts/81id61ic_Paulo%20Fagotti%20-%20Logo%20Preto.png";

/**
 * <Logo /> — Alta Agency mark
 * variant: "dark" (default, black on light bg) | "light" (white on dark bg)
 * size: css value (default 32px)
 * layout: "stack" (default, arrow above word) | "mark" (arrow only, cropped)
 */
export default function Logo({
  variant = "dark",
  size = 32,
  className = "",
  testid = "alta-logo",
  alt = "Alta Agency",
}) {
  const src = variant === "light" ? LOGO_WHITE : LOGO_BLACK;
  return (
    <img
      src={src}
      alt={alt}
      data-testid={testid}
      className={className}
      style={{ height: size, width: "auto", display: "block" }}
    />
  );
}
